import React, { FC } from 'react'
import styled from '@emotion/styled'

import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'

import backIcon from './assets/back.png'

export const SuccessIcon: FC = () => <CheckCircleOutlined style={{ fontSize: 63 }} />
export const FailIcon: FC = () => <CloseCircleOutlined style={{ fontSize: 63 }} />

export const BackIcon: FC<{ onClick: () => void }> = ({ onClick }) => {
    return <IconDiv src={backIcon} onClick={onClick} />
}

const IconDiv = styled.div<{ src: string }>`
    width: 30px;
    height: 30px;
    background-image: url(${({ src }) => src});
    background-repeat: no-repeat;
    background-size: 30px;
    cursor: pointer;
`
